import { ChangeDetectorRef, Component, Input, Output, EventEmitter } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { Subject, Subscription } from 'rxjs';
import { CreateReminderDialogService } from '../create-reminder-dialog.service';
import { QnSbnDataServiceService } from '../../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../../services/qn-sbn-service.service';
import { FormsModule } from '@angular/forms';
import { snackbarService } from '@one/web-components';
import { SnackbarService } from '../../../services/snackbar.service';
import { CreateReminderComponent } from '../../../create-notification/due-date-reminder/create-reminder/create-reminder.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'dl-reminder-table-popup',
   standalone: true,
    imports:[OneWebComponentsAngularModule,CreateReminderComponent,FormsModule],
  templateUrl: './reminder-table-popup.component.html',
  styleUrl: './reminder-table-popup.component.scss'
})
export class ReminderTablePopupComponent {

  sortInfo: { column: string, direction: string }[] = [{ column: 'DateDelivered', direction: 'desc' }];
   @Input() public displayedColumns = [];
   @Input() public tableData = [];
   @Input() public addMoreReminder: Subject<any>;
   @Input() public isDialogMode: boolean = false;
   @Input() public notificationData: any;
   @Input() public feedbackDueDate: Date | null = null;
   @Input() public onEditReminder: (data: any, originalRow: any) => void;
   @Input() public onDeleteReminder: (reminder: any) => void;
   @Output() public tableDataChange = new EventEmitter<any[]>();
    public dataSource = this.tableData;
   public selection = [];
   public selectedRow: any;
   public editRowIndex: number;
   remainderrowval:any;
   public editVisible : boolean;
   private mappingSubscription?: Subscription;
   data: { feedbackDueDate: Date; reminderData: any; remindersData: any; isEdit: boolean; isDialogMode: boolean; notificationData: any; };

   // Check if reminder date is less than or equal to today
   public isReminderDatePast(reminderDate: string): boolean {
     if (!reminderDate) return false;
     
     const today = new Date();
     today.setHours(0, 0, 0, 0);
     
     const parsedDate = this.parseReminderDateString(reminderDate);
     parsedDate.setHours(0, 0, 0, 0);
     
     return parsedDate <= today;
   }

   public constructor(
     private snackBarNotification: SnackbarService,
     private changeDetectorRef: ChangeDetectorRef,
     private createReminderDialogService: CreateReminderDialogService,
     private _QnSbnDataService: QnSbnDataServiceService,
     private qnsbnservice: QnSbnService
   ) {}
 
   public ngOnInit(): void {
       if (!this.isDialogMode) {
       this.createReminderDialogService.setRemindersDate([]);
       this.mappingSubscription = this._QnSbnDataService.mappingData$.subscribe(observer=>{ 
         if(!this._QnSbnDataService.isEmpty(observer['notificationReminders'])){
           this.updateTableData(observer['notificationReminders']['remindersData']);
         }
       });
     }
 
     this.updateTableData(this.tableData);
     
     this.sortInfo = [{ column: 'CreationDate', direction: 'desc' }];
     
     this.addMoreReminder.subscribe(data => {
      
       
       // Update tableData with proper mapping
       this.tableData = data.map(item => ({
         reminderDate: item.reminderDate || '',
         reminderSubject: item.templateDetails?.templateSubject || item.reminderSubject || '',
         reminderMessage: item.templateDetails?.templateBody || item.reminderMessage || '',
         reminderSendMode: item.reminderSendMode ?? '0',
         reminderActionIcons: true
       }));
       
       // Update dataSource to reflect in the table
       this.dataSource = [...this.tableData];
     
       this.changeDetectorRef.detectChanges();
     });
     
    
     
     // this.dataSource.sort = this.sort;
   }
 
    private updateTableData(data: any[]): void {
     this.tableData = Array.isArray(data) ? data : [];
     this.dataSource = [...this.tableData];
     if (!this.isDialogMode) {
       this.createReminderDialogService.setRemindersDate(this.tableData);
     }
     this.changeDetectorRef.detectChanges();
   }
 
   public editReminderTemplate(row: any, indx: number): void {
     if (!this.isReminderEditable(row)) {
        this.snackBarNotification.snackBarMessage('alarm', 'Cannot edit reminders that are scheduled for today or in the past')
       return;
     }
 
     this.remainderrowval = row;
     this.editRowIndex = indx;
     this.data = { 
       feedbackDueDate: this.feedbackDueDate || this.createReminderDialogService.dueDateValue, 
       reminderData: row, 
       remindersData: this.dataSource,
       isEdit: true,
       isDialogMode: this.isDialogMode,
       notificationData: this.notificationData 
     };
     this.editVisible = true; 
   }
 
   public onDialogClose(event: any): void {
     this.editVisible = false; 
     
     if (!event || !event.data) {
       this.createReminderDialogService.setRemindersDate(this.dataSource);
       return;
     }
     
     if (this.isDialogMode && this.onEditReminder) {
       this.onEditReminder(event.data[0], this.remainderrowval);
     } else {
       const updatedReminder = { ...event.data[0] };
       if (this.remainderrowval.reminderId) {
         updatedReminder.reminderId = this.remainderrowval.reminderId;
       }

       // Call createReminders API with EditReminder payload
       const notificationId = this.notificationData?.NotificationId || this.notificationData?.notificationId;
       const reminderId = this.remainderrowval.reminderId || this.remainderrowval.ReminderId || (this.editRowIndex + 1);

       if (notificationId) {
         // Parse the reminder date from the format "dd-MMM-yyyy" to Date
         let reminderDueDate: string | null = null;
         if (updatedReminder.reminderDate) {
           const parsedDate = this.parseReminderDateString(updatedReminder.reminderDate);
           reminderDueDate = parsedDate ? parsedDate.toISOString() : null;
         }

         const payload = {
           NotificationId: notificationId,
           FeedbackDueDate: this.feedbackDueDate ? new Date(this.feedbackDueDate).toISOString() : null,
           DueDateEnabled: true,
           EditReminder: [
             {
               ReminderId: reminderId,
               ReminderDueDate: reminderDueDate,
               ReminderSubject: updatedReminder.reminderSubject || '',
               ReminderMessage: updatedReminder.reminderMessage || '',
               ReminderAddTemplate: event.addToTemplate ? 'true' : '',
               ReminderSendAutomatically: updatedReminder.reminderSendMode === '1' || updatedReminder.reminderSendMode === 'Auto'
             }
           ]
         };

        

         this.qnsbnservice.createReminders(payload).subscribe({
           next: (response) => {
           
             
             // Update local data only after successful API call
             const reminderTable = [...this.dataSource];
             reminderTable[this.editRowIndex] = updatedReminder;
             this.updateTableData(reminderTable);
             this.addProduct(this.dataSource);
             this.snackBarNotification.snackBarMessage('positive', 'Reminder updated successfully');
           },
           error: (error: HttpErrorResponse) => {
           
             this.qnsbnservice.httpErrorHandler(error, 'Could not update reminder.');
           }
         });
       } else {
       
         const reminderTable = [...this.dataSource];
         reminderTable[this.editRowIndex] = updatedReminder;
         this.updateTableData(reminderTable);
         this.addProduct(this.dataSource);
         this.snackBarNotification.snackBarMessage('positive', 'Reminder updated successfully');
       }
     }
   }

   // Helper method to parse reminder date string (format: "dd-MMM-yyyy") to Date
   private parseReminderDateString(dateStr: string): Date | null {
     if (!dateStr) return null;
     
     try {
       // Handle format like "29-Jan-2026"
       const [day, monthStr, year] = dateStr.split('-');
       const monthMap: { [key: string]: number } = {
         Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
         Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
       };
       const month = monthMap[monthStr];
       if (month !== undefined) {
         return new Date(+year, month, +day);
       }
       // Fallback: try direct parsing
       return new Date(dateStr);
     } catch {
       return new Date(dateStr);
     }
   }
   
   
 
   public deleteReminderTemplate(elm: any, index: number): void {
     if (!this.isReminderRemovable(elm)) {
        this.snackBarNotification.snackBarMessage('alarm', 'Cannot delete reminders that are scheduled for today or in the past');
       return;
     }

      if (this.onDeleteReminder) {
       this.onDeleteReminder(elm);
       return;
     }

     // Call createReminders API with DeleteReminder payload
     const notificationId = this.notificationData?.NotificationId || this.notificationData?.notificationId;
     const reminderId = elm.reminderId || elm.ReminderId || (index + 1); // Use reminderId if available, otherwise use index+1

     if (notificationId) {
       const payload = {
         NotificationId: notificationId,
         FeedbackDueDate: this.feedbackDueDate ? new Date(this.feedbackDueDate).toISOString() : null,
         DueDateEnabled: true,
         DeleteReminder: [
           {
             ReminderId: reminderId
           }
         ]
       };

 

       this.qnsbnservice.createReminders(payload).subscribe({
         next: (response) => {
          
           
           // Remove from local data after successful API call
           const filtered = this.dataSource.filter(item => item !== elm);
           this.updateTableData(filtered);
           this.addProduct(filtered);
           this.tableDataChange.emit(filtered);
           this.snackBarNotification.snackBarMessage('positive', 'Reminder deleted successfully');
         },
         error: (error: HttpErrorResponse) => {
          
           this.qnsbnservice.httpErrorHandler(error, 'Could not delete reminder.');
         }
       });
     } else {
       // No notificationId, just delete locally
      
       const filtered = this.dataSource.filter(item => item !== elm);
       this.updateTableData(filtered);
       this.addProduct(filtered);
       this.tableDataChange.emit(filtered);
       this.snackBarNotification.snackBarMessage('positive', 'Reminder deleted successfully');
     }
   }
 
    public isReminderEditable(reminder: any): boolean {
     if (!reminder.reminderDate) return true;
     const reminderDate = new Date(reminder.reminderDate);
     const today = new Date();
     today.setHours(0, 0, 0, 0);
     reminderDate.setHours(0, 0, 0, 0);
     return reminderDate > today;
   }
 
   public isReminderRemovable(reminder: any): boolean {
     return this.isReminderEditable(reminder);
   }
 
   public onSendModeChange(value: Event, elm: any, index: number): void {
     this.dataSource[index].reminderSendMode = value;
   }
   public addProduct(tData) {    
     if (!this.isDialogMode) {
       this._QnSbnDataService.getMappedQnsbnData({
         "remindersData":tData     
       },"NotificationReminders"); 
     }
     // this.dataSource.data = []
  }
   ngOnDestroy(): void {
    if (!this.isDialogMode) {
      this.addProduct(this.dataSource);
    }
    this.mappingSubscription?.unsubscribe();
   }
 
   public OnSort(column: string, value: string): void {
 
     
     const existingSortIndex = this.sortInfo.findIndex(sort => sort.column === column);
     if (existingSortIndex !== -1) {
       this.sortInfo.splice(existingSortIndex, 1);
     }
     if (value !== 'default') {
       this.sortInfo.push({ column, direction: value });
     }
     this.tableData = this.applySorting(this.dataSource);
   
     
     this.changeDetectorRef.detectChanges();
   }
 
   applySorting(data: any[]): any[] {
     const dataCopy = [...data];
     if (this.sortInfo.length > 0) {
       return dataCopy.sort((a, b) => {
         for (let i = this.sortInfo.length - 1; i >= 0; i--) {
           const { column, direction } = this.sortInfo[i];
           const aValue = a[column] ?? '';
           const bValue = b[column] ?? '';
           if (aValue < bValue) return direction === 'asc' ? -1 : 1;
           if (aValue > bValue) return direction === 'asc' ? 1 : -1;
         }
         return 0;
       });
     }
     return dataCopy;
   }
 }
 
 